// Keeps the dashboard's login visible to the builder: re-creates the shared
// `token`/`userId` cookies from the dashboard session when they are missing
// (see utils/sharedAuthCookieCore.js for why). Runs on load and whenever the tab
// comes back into view; call ensureSharedAuthCookie() right after logging in and
// before sending the user to the builder.
import { sharedAuthCookieWrites } from '@/utils/sharedAuthCookieCore'
import { safeLocalStorage } from '@/lib/safe-storage'

// The dashboard's current user wins over `uRI`, which can be left over from an
// earlier login.
function currentUserId() {
    try {
        const userData = JSON.parse(safeLocalStorage.getItem('user_data') || 'null')
        if (userData?.id) return String(userData.id)
    } catch {
        /* fall back to uRI */
    }
    return safeLocalStorage.getItem('uRI')
}

export function ensureSharedAuthCookie() {
    try {
        if (typeof document === 'undefined' || typeof window === 'undefined') return
        const writes = sharedAuthCookieWrites({
            cookieString: document.cookie,
            hostname: window.location.hostname,
            token: safeLocalStorage.getItem('auth_token'),
            userId: currentUserId(),
        })
        writes.forEach((cookie) => {
            document.cookie = cookie
        })
    } catch {
        /* never let this affect the page */
    }
}

if (typeof window !== 'undefined') {
    ensureSharedAuthCookie()
    window.addEventListener('focus', ensureSharedAuthCookie)
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') ensureSharedAuthCookie()
    })
}
